// extracted by mini-css-extract-plugin
export default {"SheenBox":"SheenBox2WJP1m4xzDmO","sheen":"sheen1-vvvGzpRm0Q"};